// let triggered = false;

// // /* ===============================
// //  Css Lazyload
// // ================================ */

// function loadLazyCSS() {
//   if (window.LAZY_CSS_TRIGGERED) return;
//   window.LAZY_CSS_TRIGGERED = true;

//   const lazyCSSFiles = window.LAZY_CSS_FILES || [];

//   lazyCSSFiles.forEach(href => {
//     if (document.querySelector('link[href="' + href + '"]')) return;

//     const link = document.createElement('link');
//     link.rel = 'stylesheet';
//     link.href = href;
//     link.media = 'all';
//     document.head.appendChild(link);
//   });
// }

// /* ===============================
//  For EA Accesibilty Delay
// ================================ */
// (function () {
//     const blockedKeywords = ["accessibility", "ea-accessibility", "access-widget"];

//     const observer = new MutationObserver(function (mutations) {
//         mutations.forEach(function (mutation) {
//             mutation.addedNodes.forEach(function (node) {
//                 if (node.tagName === "SCRIPT" || node.tagName === "IFRAME") {
//                     const src = node.src || "";

//                     if (blockedKeywords.some(k => src.includes(k))) {
//                         console.log("Blocked EA Accessibility:", src);
//                         node.remove(); // remove immediately
//                     }
//                 }
//             });
//         });
//     });

//     observer.observe(document.documentElement, {
//         childList: true,
//         subtree: true
//     });

//     // Stop blocking after 5 minutes
//     setTimeout(function () {
//         console.log("Allowing EA Accessibility now");
//         observer.disconnect();
//     }, 300000); // 5 minutes
// })();


// // <!-- Hide low-rated Judge.me reviews -->
// document.addEventListener("DOMContentLoaded", function() {
//   // Function to hide low-rated reviews
//   function hideLowReviews() {
//     const reviews = document.querySelectorAll(".jdgm-rev");
//     reviews.forEach(review => {
//       const ratingSpan = review.querySelector(".jdgm-rev__rating");
//       if (ratingSpan) {
//         const ariaLabel = ratingSpan.getAttribute("aria-label");
//         if (ariaLabel && (ariaLabel.includes("1 star") || ariaLabel.includes("2 star") || ariaLabel.includes("3 star"))) {
//           review.style.display = "none";
//         }
//       }
//     });
//   }

//   // Initial call
//   hideLowReviews();

//   // Observe all future DOM changes inside the widget
//   const container = document.querySelector(".jdgm-rev-widg__reviews");
//   if (container) {
//     const observer = new MutationObserver(function(mutationsList) {
//       mutationsList.forEach(mutation => {
//         if (mutation.addedNodes.length > 0) {
//           hideLowReviews();
//         }
//       });
//     });
//     observer.observe(container, { childList: true, subtree: true });
//   }

//   // Optional: repeat every 2 seconds as a fallback
//   setInterval(hideLowReviews, 2000);
// });


//   // <!-- ----------FOR HEADER FIXED AND SERACH BOX ----------- -->
//       document.addEventListener('DOMContentLoaded', function () {
//         const header = document.querySelector('.site-header');

//         function handleScroll() {
//           const currentScrollY = window.scrollY;

//           if (currentScrollY > 100) {
//             header.classList.add('header-fixed');
//           } else {
//             header.classList.remove('header-fixed');
//           }
//         }

//         function initScrollBehavior() {
//           if (window.innerWidth < 769) {
//             // Add scroll listener
//             window.addEventListener('scroll', handleScroll, { passive: true });

//             // Immediately check scroll position on load
//             handleScroll();
//           } else {
//             // Ensure scroll listener is removed for larger screens
//             window.removeEventListener('scroll', handleScroll);
//             header.classList.remove('header-fixed');
//           }
//         }

//         // Init on load
//         initScrollBehavior();

//         // Re-check on window resize
//         window.addEventListener('resize', function () {
//           initScrollBehavior(); // Re-run logic on resize
//         });
//       });
//     // <!-- ----------FOR METAFIELD LINK BOXES ARROWS SLIDER----------- -->

//       (function () {
//         let triggered = false;

//         function initScrollLinkBoxes() {
//           const setups = [
//             {
//               containerSelector: '.custom-link-boxes-wrapper',
//               scrollSelector: '.metafield-rich_text_field',
//               hideButtonsIfFewChildren: true,
//               childSelector: 'p',
//               scrollAmount: 200,
//             },
//             {
//               containerSelector: '.link-boxes-container',
//               scrollSelector: '.link-boxes_wrapper',
//               hideButtonsIfFewChildren: false,
//               scrollAmountPerContainer: true,
//             },
//           ];

//           setups.forEach((setup) => {
//             const containers = document.querySelectorAll(setup.containerSelector);

//             containers.forEach((container) => {
//               const scrollContainer = container.querySelector(setup.scrollSelector);
//               const prevBtn = container.querySelector('.button-prev');
//               const nextBtn = container.querySelector('.button-next');

//               if (!scrollContainer || !prevBtn || !nextBtn) return;

//               if (setup.hideButtonsIfFewChildren && setup.childSelector) {
//                 const children = scrollContainer.querySelectorAll(setup.childSelector);
//                 if (children.length <= 3) {
//                   prevBtn.style.display = 'none';
//                   nextBtn.style.display = 'none';
//                 } else {
//                   prevBtn.style.display = 'block';
//                   nextBtn.style.display = 'block';
//                 }
//               }

//               scrollContainer.style.overflowX = 'auto';
//               scrollContainer.style.whiteSpace = 'nowrap';

//               const scrollAmount = setup.scrollAmountPerContainer
//                 ? scrollContainer.clientWidth / 4
//                 : setup.scrollAmount;

//               prevBtn.addEventListener('click', () => {
//                 scrollContainer.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
//               });

//               nextBtn.addEventListener('click', () => {
//                 scrollContainer.scrollBy({ left: scrollAmount, behavior: 'smooth' });
//               });
//             });
//           });
//         }

//         function onUserInteraction() {
//           if (triggered) return;
//           triggered = true;
//           initScrollLinkBoxes();
//         }

//         ['scroll', 'mousemove', 'touchstart', 'keydown', 'click'].forEach((evt) => {
//           window.addEventListener(evt, onUserInteraction, { once: true, passive: true });
//         });
//       })();

// // REVIEWS BADGE ON NAV
//       document.addEventListener('DOMContentLoaded', () => {
//         const nav = document.querySelector('.site-mobile-nav');
//         const badge = document.querySelector('.reviews-badge');
//         if (!nav || !badge) return;

//         const originalDisplay = getComputedStyle(badge).display || 'flex';

//         const updateBadge = () => {
//           badge.style.display = nav.getAttribute('data-open') === 'true' ? 'none' : originalDisplay;
//         };

//         // initial
//         updateBadge();

//         // observe future changes to data-open
//         new MutationObserver((mutations) => {
//           for (const m of mutations) {
//             if (m.type === 'attributes' && m.attributeName === 'data-open') {
//               updateBadge();
//             }
//           }
//         }).observe(nav, { attributes: true, attributeFilter: ['data-open'] });
//       });

// // SEARCH TEXT ANIMATION
//       document.addEventListener('DOMContentLoaded', function () {
//         const textContainer = document.querySelector('.search-text-animation');
//         let words = [];
//         if (textContainer) {
//           words = textContainer.innerText
//             .split(',')
//             .map((w) => w.trim())
//             .filter((w) => w.length);
//         }
//         const inputs = document.querySelectorAll('.search-animate');
//         let wordIndex = 0;
//         let charIndex = 0;
//         let currentWord = '';
//         let typingSpeed = 100; // speed of typing (ms)
//         let delayBetweenWords = 1500; // rukne ka time (ms)
//         function typeWord() {
//           if (!words || words.length === 0) return;
//           currentWord = words[wordIndex];
//           if (!currentWord) return;
//           inputs.forEach((input) => {
//             input.placeholder = 'Search for ' + currentWord.slice(0, charIndex);
//           });
//           charIndex++;
//           // Jab pura word type ho jaye
//           if (charIndex <= currentWord.length) {
//             setTimeout(typeWord, typingSpeed);
//           } else {
//             // Agle word pe jump
//             setTimeout(() => {
//               wordIndex = (wordIndex + 1) % words.length;
//               charIndex = 0;
//               typeWord();
//             }, delayBetweenWords);
//           }
//         }
//         typeWord(); // Initial run
//       });

// /* ===============================
//  Master Initializer
// ================================ */
// function runAllDeferredFeatures() {
//   if (triggered) return;
//   triggered = true;

//   loadLazyCSS();

// }

// /* ===============================
//  Interaction-based Trigger
// ================================ */
// (function () {
//   ['scroll', 'mousemove', 'touchstart', 'keydown', 'click'].forEach(evt => {
//     window.addEventListener(evt, runAllDeferredFeatures, {
//       once: true,
//       passive: true
//     });
//   });
  
//   ['facet:update', 'theme:loading:end'].forEach(evt => {
//     window.addEventListener(evt, () => {
//       setTimeout(() => {
//         triggered = false; // allow re-run
//         runAllDeferredFeatures();
//       }, 100);
//     });
//   });
// })();


/* ===============================
Initial Trigger
================================ */
if (typeof initProductSwipers === 'function') { try { initProductSwipers(); } catch(e) { console.warn('initProductSwipers early call:', e); } }
/* ===============================
Delayed After-Load Trigger
================================ */
function onPageFullyLoaded(cb) {
  if (document.readyState === 'complete') {
    cb();
  } else {
    window.addEventListener('load', cb);
  }
}

onPageFullyLoaded(function () {
  initProductSwipers();
});

document.addEventListener('submit', function(e) {
  // 1. Check if the submitted form is a search form
  const searchForm = e.target.closest('form[action^="/search"]');
  
  if (searchForm) {
    // 2. Find the search input field (usually named "q")
    const input = searchForm.querySelector('input[name="q"]');
    
    if (input && input.value) {
      // 3. Remove all types of apostrophes and curly quotes
      // This turns "Men's Suit" into "Mens Suit"
      const cleanedValue = input.value.replace(/['’‘]/g, '').replace(/&#39;/g, '');;
      
      // 4. Update the input value before the form actually sends
      input.value = cleanedValue;
    }
  }
});

// SAQ

let triggered = false;

/* ===============================
   CSS Lazyload
================================ */
function loadLazyCSS() {
  if (window.LAZY_CSS_TRIGGERED) return;
  window.LAZY_CSS_TRIGGERED = true;

  const lazyCSSFiles = window.LAZY_CSS_FILES || [];

  lazyCSSFiles.forEach(href => {
    if (document.querySelector('link[href="' + href + '"]')) return;

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.media = 'all';
    document.head.appendChild(link);
  });
}

/* ===============================
   EA Accessibility Delay
================================ */
function initAccessibilityBlocker() {
  const blockedKeywords = ["accessibility", "ea-accessibility", "access-widget"];

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.tagName === "SCRIPT" || node.tagName === "IFRAME") {
          const src = node.src || "";

          if (blockedKeywords.some(k => src.includes(k))) {
            console.log("Blocked EA Accessibility:", src);
            node.remove();
          }
        }
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  setTimeout(function () {
    console.log("Allowing EA Accessibility now");
    observer.disconnect();
  }, 300000);
}

/* ===============================
   Hide Low-rated Judge.me Reviews
================================ */
function initHideLowReviews() {
  function hideLowReviews() {
    const reviews = document.querySelectorAll(".jdgm-rev");

    reviews.forEach(review => {
      const ratingSpan = review.querySelector(".jdgm-rev__rating");

      if (ratingSpan) {
        const ariaLabel = ratingSpan.getAttribute("aria-label");

        if (
          ariaLabel &&
          (ariaLabel.includes("1 star") ||
            ariaLabel.includes("2 star") ||
            ariaLabel.includes("3 star"))
        ) {
          review.style.display = "none";
        }
      }
    });
  }

  hideLowReviews();

  const container = document.querySelector(".jdgm-rev-widg__reviews");

  if (container) {
    const observer = new MutationObserver(function (mutationsList) {
      mutationsList.forEach(mutation => {
        if (mutation.addedNodes.length > 0) {
          hideLowReviews();
        }
      });
    });

    observer.observe(container, { childList: true, subtree: true });
  }

  setInterval(hideLowReviews, 2000);
}

/* ===============================
   Header Fixed
================================ */
function initHeaderFixed() {
  const header = document.querySelector('.site-header');
  if (!header) return;

  function handleScroll() {
    const currentScrollY = window.scrollY;

    if (currentScrollY > 100) {
      header.classList.add('header-fixed');
    } else {
      header.classList.remove('header-fixed');
    }
  }

  function initScrollBehavior() {
    if (window.innerWidth < 769) {
      window.addEventListener('scroll', handleScroll, { passive: true });
      handleScroll();
    } else {
      window.removeEventListener('scroll', handleScroll);
      header.classList.remove('header-fixed');
    }
  }

  initScrollBehavior();

  window.addEventListener('resize', function () {
    initScrollBehavior();
  });
}

/* ===============================
   Metafield Link Boxes Slider
================================ */
function initScrollLinkBoxes() {
  const setups = [
    {
      containerSelector: '.custom-link-boxes-wrapper',
      scrollSelector: '.metafield-rich_text_field',
      hideButtonsIfFewChildren: true,
      childSelector: 'p',
      scrollAmount: 200,
    },
    {
      containerSelector: '.link-boxes-container',
      scrollSelector: '.link-boxes_wrapper',
      hideButtonsIfFewChildren: false,
      scrollAmountPerContainer: true,
    },
  ];

  setups.forEach((setup) => {
    const containers = document.querySelectorAll(setup.containerSelector);

    containers.forEach((container) => {
      const scrollContainer = container.querySelector(setup.scrollSelector);
      const prevBtn = container.querySelector('.button-prev');
      const nextBtn = container.querySelector('.button-next');

      if (!scrollContainer || !prevBtn || !nextBtn) return;

      if (setup.hideButtonsIfFewChildren && setup.childSelector) {
        const children = scrollContainer.querySelectorAll(setup.childSelector);

        if (children.length <= 3) {
          prevBtn.style.display = 'none';
          nextBtn.style.display = 'none';
        } else {
          prevBtn.style.display = 'block';
          nextBtn.style.display = 'block';
        }
      }

      scrollContainer.style.overflowX = 'auto';
      scrollContainer.style.whiteSpace = 'nowrap';

      const scrollAmount = setup.scrollAmountPerContainer
        ? scrollContainer.clientWidth / 4
        : setup.scrollAmount;

      prevBtn.addEventListener('click', () => {
        scrollContainer.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', () => {
        scrollContainer.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });
    });
  });
}

/* ===============================
   Reviews Badge on Nav
================================ */
function initReviewsBadgeNav() {
  const nav = document.querySelector('.site-mobile-nav');
  const badge = document.querySelector('.reviews-badge');

  if (!nav || !badge) return;

  const originalDisplay = getComputedStyle(badge).display || 'flex';

  const updateBadge = () => {
    badge.style.display =
      nav.getAttribute('data-open') === 'true' ? 'none' : originalDisplay;
  };

  updateBadge();

  new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === 'attributes' && m.attributeName === 'data-open') {
        updateBadge();
      }
    }
  }).observe(nav, { attributes: true, attributeFilter: ['data-open'] });
}

/* ===============================
   Search Text Animation
================================ */
function initSearchTextAnimation() {
  const textContainer = document.querySelector('.search-text-animation');
  let words = [];

  if (textContainer) {
    words = textContainer.innerText
      .split(',')
      .map((w) => w.trim())
      .filter((w) => w.length);
  }

  const inputs = document.querySelectorAll('.search-animate');
  let wordIndex = 0;
  let charIndex = 0;
  let currentWord = '';
  let typingSpeed = 100;
  let delayBetweenWords = 1500;

  function typeWord() {
    if (!words || words.length === 0) return;

    currentWord = words[wordIndex];
    if (!currentWord) return;

    inputs.forEach((input) => {
      input.placeholder = 'Search for ' + currentWord.slice(0, charIndex);
    });

    charIndex++;

    if (charIndex <= currentWord.length) {
      setTimeout(typeWord, typingSpeed);
    } else {
      setTimeout(() => {
        wordIndex = (wordIndex + 1) % words.length;
        charIndex = 0;
        typeWord();
      }, delayBetweenWords);
    }
  }

  typeWord();
}

/* ===============================
   Master Initializer
================================ */
function runAllDeferredFeatures() {
  if (triggered) return;
  triggered = true;

  loadLazyCSS();
  initAccessibilityBlocker();
  initHideLowReviews();
  initHeaderFixed();
  initScrollLinkBoxes();
  initReviewsBadgeNav();
  initSearchTextAnimation();
}

/* ===============================
   Interaction-based Trigger
================================ */
(function () {
  ['scroll', 'mousemove', 'touchstart', 'keydown', 'click'].forEach(evt => {
    window.addEventListener(evt, runAllDeferredFeatures, {
      once: true,
      passive: true
    });
  });

  ['facet:update', 'theme:loading:end'].forEach(evt => {
    window.addEventListener(evt, () => {
      setTimeout(() => {
        triggered = false;
        runAllDeferredFeatures();
      }, 100);
    });
  });
})();